import { render, staticRenderFns } from "./SportsProfile.vue?vue&type=template&id=3ea609c4&"
import script from "./SportsProfile.vue?vue&type=script&lang=js&"
export * from "./SportsProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports